export default class BaseConcurrencyRequest {

    public lastModifiedAt: Date | null = null;
}